exports = module.exports = require("../../../node_modules/react-scripts/node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".my-modal {\n  cursor: auto;\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: rgba(0, 0, 0, 0.6);\n}\n\n.my-modal-main {\n  position: fixed;\n  background: #ffffff;\n  width: 352px;\n  height: 445px;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  box-shadow: 0 12px 24px 0 rgba(0, 0, 0, 0.18);\n}\n\n.my-display-block {\n  display: block;\n}\n\n.my-display-none {\n  display: none;\n}", ""]);

// exports
